<template>
  <OLoading :active="isActive" :full-page="true" :can-cancel="true">
    <span class="icon is-spin">
      <SpriteSymbol name="circle-notch" />
    </span>
  </OLoading>
</template>

<script lang="ts">
import { OLoading } from '@oruga-ui/oruga-next'

export default {
  components: { OLoading },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.o-load {
  .icon {
    color: $grey;
  }
}
</style>
